import { GlobalMessages } from '@shared/localization/messages';

import { Button } from '@/components/atoms/Button';
import { useMessages } from '@/hooks/messages';

export interface SecondaryAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export interface ITabHeaderProps {
  title: string;
  subTitle?: string;
  createLabel?: string;
  saveButtonDisabled?: boolean;
  saveButtonProcessing?: boolean;
  onSave?: () => void;
  onCreate?: () => void;
  onAdditionalCreate?: () => void;
  additionalCreateLabel?: string;
  secondaryActions?: SecondaryAction[];
}

export const TabHeader = ({
  title,
  subTitle,
  createLabel,
  saveButtonDisabled,
  saveButtonProcessing,
  onSave,
  onCreate,
  onAdditionalCreate,
  additionalCreateLabel,
  secondaryActions,
}: ITabHeaderProps) => {
  const globalMessages = useMessages(GlobalMessages);

  return (
    <div className='align-center mb-5 flex'>
      {title && (
        <div className='flex-1 pr-2'>
          <h1 className='m-0'>{title}</h1>
        </div>
      )}

      {subTitle && (
        <div>
          <h5 className='text-secondary mb-3'>{subTitle}</h5>
        </div>
      )}

      {(onSave || onCreate || secondaryActions?.length) && (
        <div className='flex flex-wrap items-end justify-end gap-2 self-center'>
          {secondaryActions?.map((action) => (
            <Button
              key={action.label}
              type='button'
              onClick={action.onClick}
              disabled={action.disabled}
              variant='success'
              size='sm'
              outlined={true}
            >
              {action.label}
            </Button>
          ))}
          {onAdditionalCreate && (
            <button
              onClick={onAdditionalCreate}
              type='button'
              className='btn btn-outline-success btn-sm'
            >
              {additionalCreateLabel}
            </button>
          )}
          {onCreate && (
            <button onClick={onCreate} type='button' className='btn btn-outline-success btn-sm'>
              {createLabel}
            </button>
          )}
          {onSave && (
            <Button
              disabled={saveButtonDisabled}
              onClick={onSave}
              variant='success'
              size='sm'
              outlined={true}
              isProcessing={saveButtonProcessing}
            >
              {globalMessages.saveAllChanges()}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
